// @flow
export const TEXT_AREA_THEME_API = {
  textarea: '',
  disabled: '',
  errored: ''
};
